/* eslint-disable import/no-anonymous-default-export */
import { SET_ALWAYS_ON_TOP } from '../actionConstants';

export default (state = true, action) => {
  switch (action.type) {
    case SET_ALWAYS_ON_TOP:
      return action.payload;
    default:
      return state;
  }
};
